import { createTheme } from '@mui/material/styles';

// const cssVar = (name: string) =>
//   getComputedStyle(document.documentElement).getPropertyValue(name).trim();

const sizeButton = {
  medium: '8px 16px 12px 16px',
  large: '12px 18px 16px 18px',
};

export let theme = createTheme({
  palette: {
    primary: {
      main: '#910000',
    },
    background: {
      default: '#181818',
    },
    text: {
      primary: '#fff',
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        fontFamily: 'Public Sans',
        variantMapping: {
          label1: 'p',
          label2: 'p',
          label3: 'p',
          body3: 'p',
          button1: 'p',
          button2: 'p',
          caption1: 'p',
          caption2: 'p',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true,
        size: 'medium',
      },
      styleOverrides: {
        sizeLarge: {
          padding: sizeButton.large,
          fontSize: '32px',
          fontWeight: 400,
          lineHeight: '32px',
          letterSpacing: '-0.022em',
        },
        sizeMedium: {
          padding: sizeButton.medium,
          fontSize: '24px',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '-0.022em',
        },

        root: ({ ownerState }) => ({
          borderRadius: 0,
          textTransform: 'none',
          fontWeight: 400,
          boxShadow: 'none',
          border: '1px solid #fff',
          background: 'transparent',
          color: '#fff',

          '&.Mui-disabled': {
            background: 'var(--grey-neutral-80)',
            color: 'var(--text-disable)',
          },
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'primary' && {
              color: '#fff',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'var(--primary)',
                border: '1px solid var(--primary)',
              },
              '&:active': {
                border: '1px solid var(--secondary-04)',
                backgroundColor: 'var(--secondary-04)',
                boxShadow: 'none',
              },
            }),
          ...(ownerState.variant === 'contained' &&
            ownerState.color === 'secondary' && {
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'var(--primary)',
              },
              '&:active': {
                backgroundColor: 'var(--secondary-04)',
                boxShadow: 'none',
              },
            }),

          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'primary' && {
              color: '#fff ',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'var(--primary)',
              },
              '&:active': {
                backgroundColor: 'var(--secondary-04)',
                boxShadow: 'none',
              },
            }),
          ...(ownerState.variant === 'outlined' &&
            ownerState.color === 'secondary' && {
              color: '#fff ',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'var(--primary)',
              },
              '&:active': {
                backgroundColor: 'var(--secondary-04)',
                boxShadow: 'none',
              },
            }),

          ...(ownerState.variant === 'text' &&
            ownerState.color === 'primary' && {
              color: 'var(--primary)',

              '&:hover': {
                textDecoration: 'underline',
              },
              '&:active': {
                color: 'var(--text-primary)',
              },
            }),
        }),
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0,
          color: 'var(--grey-neutral-100)',
          '& .MuiButtonBase-root': {
            color: 'var(--grey-neutral-100)',
          },

          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: 'var(--primary)',
          },
          '&.Mui-disabled': {
            color: 'var(--grey-neutral-100)',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: 'var(--grey-neutral-100)',

          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: 'var(--primary)',
          },
          '&.Mui-disabled': {
            color: 'var(--grey-neutral-100)',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 44,
          height: 24,
          padding: 0,
          display: 'flex',

          '& .MuiSwitch-switchBase': {
            top: '-7px',
            left: '-7px',
            '&.Mui-checked': {
              transform: 'translateX(20px)',

              color: '#fff',
              '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'var(--primary)',
              },
            },
          },
          '& .MuiSwitch-thumb': {
            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
            width: 20,
            height: 20,
            borderRadius: 10,
          },
          '& .MuiSwitch-track': {
            borderRadius: 24 / 2,
            opacity: 1,
            backgroundColor: 'var(--text-disable)',
            boxSizing: 'border-box',
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        fullWidth: true,
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--border-color)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--grey-neutral-300)',
          },

          '&.MuiInputBase-root': {
            height: '40px',
            borderRadius: '6px',
          },
        }),
      },
    },
    // MuiDataGrid: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: cssVar('--#fff'),
    //       border: 'none',
    //       '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
    //         outline: 'none !important',
    //       },

    //       '& .MuiDataGrid-row': {
    //         '&.Mui-selected': {
    //           // backgroundColor: "yellow",
    //         },
    //         '&.Mui-selected:hover': {
    //           // backgroundColor: "red",
    //         },
    //       },
    //     },
    //   },
    // },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        InputLabelProps: {
          shrink: false,
        },
      },

      styleOverrides: {
        root: ({ ownerState }) => ({
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
            marginTop: '6px',
            '&.Mui-error': {
              color: 'var(--alert)',
            },
            borderRadius: '2px',
          },
          '& .MuiInputLabel-root': {
            position: 'static',
            color: 'var(--text-primary)',
            transform: 'none',
            fontWeight: '600',
            fontSize: '14px',
            marginBottom: '8px',
            '&.Mui-focused ': {
              color: 'var(--text-primary)',
            },
            '&.Mui-error ': {
              color: 'var(--text-primary)',
            },
            '&.Mui-disabled ': {
              color: 'var(--text-tertiary)',
            },
          },
          '& .MuiOutlinedInput-root': {
            borderRadius: '2px',
            '& input': {
              color: 'var(--text-primary)',
              '&::placeholder': {
                color: 'var(--text-secondary)',
                fontSize: 16,
                height: '24px',
              },
              overflow: 'hidden',
              fontSize: 16,
              padding: '8px 16px',
              height: '24px',
            },
            '& fieldset': {
              border: '1px solid',
              borderColor: 'var(--border-color)',
            },

            //hover
            '&:hover fieldset': {
              borderColor: 'var(--grey-neutral-300)',
            },
            //focus
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--primary)',
              borderWidth: '1px',
            },

            '&.Mui-error fieldset': {
              borderColor: 'var(--alert) ',
            },
            '&.Mui-disabled fieldset': {
              borderColor: 'var(--grey-neutral-200)',
              color: 'var(--text-disable)',
            },
          },
          '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: 'var(--grey-neutral-80)',
            color: 'var(--text-disable)',
          },
        }),
      },
    },
    MuiTab: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          textTransform: 'none',
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          padding: 0,
        }),
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: ({ owerState }) => ({
          '&.MuiSnackbar-anchorOriginTopRight': {
            left: 'auto',
          },
        }),
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          border: '1px solid',
          borderRadius: '8px',

          '&.MuiAlert-root': {
            width: '450px',
            backgroundColor: 'var(--grey-primary-900)',
            padding: '24px',
            '& .MuiAlert-icon': {
              padding: '0 16px 0 0',
              margin: 0,
            },
            '& .MuiAlert-action': {
              color: '#fff',
            },
            '& .MuiAlert-message': {
              padding: 0,
              color: '#fff',
              '& .MuiAlertTitle-root': {
                marginBottom: '8px',
              },
            },
          },
        }),
      },
    },
    MuiMenu: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          borderRadius: '100px',
          '& .MuiPaper-root': {
            marginTop: '5px',
            padding: '12px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            borderColor: 'var(--border-color)',
            boxShadow: '0px 2px 16px 0px rgba(8, 53, 53, 0.12)',
          },
          '& .MuiList-root': {
            padding: '0px',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          },
          '& .MuiButtonBase-root': {
            borderRadius: '6px',
            padding: '0 12px',
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          '&:hover': {
            backgroundColor: 'var(--grey-primary-60)',
          },
          '&.Mui-selected': {
            backgroundColor: 'var(--grey-primary-60)',
            '&.Mui-focusVisible': {
              color: 'var(--primary)',
              backgroundColor: 'var(--grey-primary-60)',
            },

            '&:hover': {
              backgroundColor: 'var(--grey-primary-60)',
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          '&:hover': {
            backgroundColor: 'var(--grey-primary-60)',
          },

          '&.Mui-selected': {
            backgroundColor: 'var(--grey-primary-60)',
            '&.Mui-focusVisible': {
              color: 'var(--primary)',
              backgroundColor: 'var(--grey-primary-60)',
            },

            '&:hover': {
              backgroundColor: 'var(--grey-primary-60)',
            },
          },
        },
      },
    },
  },
  typography: {
    fontFamily: ['Public Sans', 'Cormorant Garamond'].join(','),
    h1: {
      fontSize: '91.2px',
      fontWeight: 500,
      lineHeight: '91.2px',
      letterSpacing: '-0.022em',
      '@media (min-width:1440px)': {
        fontSize: '104px',
        lineHeight: '104px',
      },
    },
    h2: {
      fontSize: '54.4px',
      fontWeight: 500,
      lineHeight: '54.4px',
      letterSpacing: '-0.022em',
      '@media (min-width:1440px)': {
        fontSize: '80px',
        lineHeight: '80px',
      },
    },
    h3: {
      fontSize: '48px',
      fontWeight: 500,
      lineHeight: '48px',
      letterSpacing: '-0.022em',
      '@media (min-width:1440px)': {
        fontSize: '66.6px',
        lineHeight: '66.6px',
      },
    },
    h4: {
      fontSize: '32px',
      fontWeight: 500,
      lineHeight: '32px',
      letterSpacing: '-0.022em',
      '@media (min-width:1440px)': {
        fontSize: '39.6px',
        lineHeight: '43.56px',
      },
    },
    h5: {
      fontSize: '19.2px',
      fontWeight: 400,
      lineHeight: '19.2px',
      letterSpacing: '-0.022em',
      '@media (min-width:1440px)': {
        fontSize: '25.2px',
        lineHeight: '25.2px',
      },
    },
    body1: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '17.6px',
      letterSpacing: '-0.022em',
      '@media (min-width:1440px)': {
        fontSize: '18px',
        lineHeight: '19.8px',
      },
    },
  },
  breakpoints: {
    values: {
      mobile: 0,
      mini:450,
      tablet: 744,
      desktop: 1024,
      oversize: 1440,
    },
  },
});
